import { proxy } from 'valtio';

type StateProps = {
  entryId: string;
  isActionBarEnabled: boolean;
  totalSelectedCount: number;
  contentId: string;
};

const createActionBarState = () => {
  const state: StateProps = proxy({
    entryId: '',
    isActionBarEnabled: false,
    totalSelectedCount: 0,
    contentId: '',
  });
  const setActionBarState = (partialState: Partial<StateProps>) => {
    Object.assign(state, partialState);
  };

  return {
    state,
    setActionBarState,
  };
};

export const actionBarState = createActionBarState();
